<div class="flex flex-col" [formGroup]="formGroup">
  <div class="flex flex-col sm:flex-row gap-2 items-start">
    <mat-form-field class="flex-grow" floatLabel="always">
      <mat-label i18n>Company</mat-label>
      <input placeholder="Company" i18n-placeholder #organizationInput matInput [matAutocomplete]="organizationAutocomplete" formControlName="organization" (change)="userChange()" (focus)="cardSearchFocused$.next(true)" (blur)="cardSearchFocused$.next(false)">
      @if (cardSearchBusy$ | async) {
        <span matSuffix>
          <mat-spinner diameter="16"></mat-spinner>
        </span>
      }
      @if (!(cardSearchBusy$ | async)) {
        <span matSuffix>
          <app-icon class="arrow" [icon]="organizationAutocomplete.isOpen ? 'caret-up' : 'search'"></app-icon>
        </span>
      }
      <mat-error>{{ organizationControl.errors?.violations[0]?.message }}</mat-error>
      <mat-autocomplete #organizationAutocomplete (optionSelected)="onCardSearchSelection($event)" panelWidth="400px">
        @for (cardHeader of cardSearch$ | async; track cardHeader) {
          <mat-option value="{{ cardHeader.id }}" class="flex flex-col w-100">
            <div class="font-bold">{{ cardHeader.title }}</div>
            <div class="flex flex-row text-xs w-100">
              <span class="flex-grow">{{ cardHeader.summary }}</span>
              <span class="text-right opacity-50">{{ cardHeader.providerDisplay }}</span>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="flex-grow" floatLabel="always">
      <mat-label i18n>Attn</mat-label>
      <input placeholder="Attn" i18n-placeholder #attnInput matInput formControlName="attn" (change)="userChange()">
      <mat-error>{{ attnControl.errors?.violations[0]?.message }}</mat-error>
    </mat-form-field>
    <app-country-field class="flex grow" [control]="countryControl" (change)="userChange()"></app-country-field>
    <!--
    <mat-form-field class="flex-grow narrow-infix" floatLabel="always" hideRequiredMarker="true">
      <mat-label i18n>Country</mat-label>
      <input matInput #countryInput [matAutocomplete]="countryAutocomplete" formControlName="country" (input)="countryChanged()">
      <mat-autocomplete #countryAutocomplete (optionSelected)="onCountrySearchSelection($event)">
        <mat-option *ngFor="let country of filteredCountries$ | async" [value]="country">
          {{ country | countryName }}
        </mat-option>
      </mat-autocomplete>
      <span matTextSuffix class="opacity-50">{{ countryControl.value | countryName }}</span>
      <mat-error *ngIf="countryControl.invalid">{{ getErrorMessage('country') }}</mat-error>
    </mat-form-field>
    -->
  </div>
  <div class="flex gap-2 flex-col sm:flex-row items-start">
    <div class="flex flex-row gap-2 items-start">
      @if (postalCodeControlVisible$ | async) {
        <mat-form-field class="grow basis-1/4" floatLabel="always">
          <mat-label>{{ postalCodeCaption$ | async }}</mat-label>
          <input placeholder="{{ postalCodeCaption$ | async }}" matInput formControlName="postalCode" (change)="userChange()" (blur)="postalCodeBlur()">
          <mat-error>{{ postalCodeControl.errors?.violations[0]?.message }}</mat-error>
        </mat-form-field>
      }
      @if (provinceControlVisible$ | async) {
        <mat-form-field class="narrow-infix grow basis-1/3" floatLabel="always">
          <mat-label>{{ provinceCaption$ | async }}</mat-label>
          <input matInput placeholder="{{ provinceCaption$ | async }}" #provinceInput [matAutocomplete]="provinceAutocomplete" formControlName="province" (change)="userChange()" (input)="provinceChanged()" (blur)="provinceBlur()">
          <mat-error>{{ provinceControl.errors?.violations[0]?.message }}</mat-error>
          <mat-autocomplete #provinceAutocomplete (optionSelected)="onProvinceSearchSelection($event)">
            @for (province of filteredProvinces$ | async; track province) {
              <mat-option [value]="province">{{ province | provinceName:countryControl.value }}</mat-option>
            }
          </mat-autocomplete>
          <span matTextSuffix class="opacity-50">{{ provinceControl.value | provinceName:countryControl.value }}</span>
        </mat-form-field>
      }
    </div>
    <mat-form-field class="grow basis-1/2" floatLabel="always">
      <mat-label i18n>City</mat-label>
      <input placeholder="City" i18n-placeholder #cityInput matInput formControlName="city" (change)="userChange()" [matAutocomplete]="cityAutocomplete">
      <mat-error>{{ cityControl.errors?.violations[0]?.message }}</mat-error>
      <mat-autocomplete #cityAutocomplete (optionSelected)="onCitySearchSelection($event)">
        @for (geo of citySearch$ | async; track geo) {
          <mat-option [value]="geo">
            {{ geo.city }}{{ geo.province ? ', ' + geo.province : '' }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="flex gap-2 flex-col sm:flex-row items-start">
    <mat-form-field class="grow basis-1/2" floatLabel="always">
      <mat-label i18n>Street 1</mat-label>
      <input placeholder="Street 1" i18n-placeholder #street1Input matInput formControlName="street1" (change)="userChange()">
      <mat-error>{{ street1Control.errors?.violations[0]?.message }}</mat-error>
    </mat-form-field>
    <mat-form-field class="grow basis-1/3" floatLabel="always">
      <mat-label i18n>Street 2</mat-label>
      <input placeholder="Street 2" i18n-placeholder #street2Input matInput formControlName="street2" (change)="userChange()">
      <mat-error>{{ street2Control.errors?.violations[0]?.message }}</mat-error>
    </mat-form-field>
    <mat-form-field class="grow basis-1/4" floatLabel="always">
      <mat-label i18n>Street 3</mat-label>
      <input placeholder="Street 3" i18n-placeholder #street3Input matInput formControlName="street3" (change)="userChange()">
      <mat-error>{{ street3Control.errors?.violations[0]?.message }}</mat-error>
    </mat-form-field>
  </div>
  <div class="flex gap-2 flex-col sm:flex-row items-start">
    <mat-form-field class="grow basis-1/2" floatLabel="always">
      <mat-label i18n>E-mail</mat-label>
      <input placeholder="E-mail" i18n-placeholder matInput formControlName="email" (change)="userChange()">
      <mat-error>{{ emailControl.errors?.violations[0]?.message }}</mat-error>
    </mat-form-field>
    <div class="flex flex-row gap-2 items-start">
      <mat-form-field class="grow basis-1/3" floatLabel="always">
        <mat-label i18n>Telephone</mat-label>
        <input placeholder="Telephone" i18n-placeholder matInput formControlName="telephone" (change)="userChange()">
        <mat-error>{{ telephoneControl.errors?.violations[0]?.message }}</mat-error>
      </mat-form-field>
      <mat-form-field class="flex-none w-36" floatLabel="always">
        <mat-label i18n>Address Type</mat-label>
        <mat-select placeholder="Address Type" i18n-placeholder formControlName="residentialFlag" (change)="userChange()">
          <mat-option [value]="false" i18n>Commercial</mat-option>
          <mat-option [value]="true" i18n>Residential</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
    @if (showTimes$ | async) {
        <div class="flex gap-2 flex-row items-start">
            @if (showDate$ | async) {
                <mat-form-field floatLabel="always" class="basis-1/2 min-w-0">
                    <mat-label i18n>Pickup Date</mat-label>
                    <input placeholder="Pickup Date" i18n-placeholder matInput [matDatepicker]="shipmentDatePicker" [formControl]="shipmentDateControl" (change)="userChange()">
                    <mat-error>{{ shipmentDateControl.errors?.violations[0]?.message }}</mat-error>
                    <mat-datepicker-toggle matSuffix [for]="shipmentDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #shipmentDatePicker></mat-datepicker>
                </mat-form-field>
            }
            @if (cardType == cardTypeEnum.SHIPPER) {
                <app-time-field class="grow shrink basis-1/2 min-w-0" caption="Ready Time" i18n-caption [control]="openTimeControl" (change)="userChange()"></app-time-field>
            } @else {
                <app-time-field class="grow shrink basis-1/2 min-w-0" caption="Open Time" i18n-caption [control]="openTimeControl" (change)="userChange()"></app-time-field>
            }
            <app-time-field class="grow shrink basis-1/2 min-w-0" caption="Closing Time" i18n-caption [control]="closeTimeControl" (change)="userChange()"></app-time-field>
        </div>
    }
</div>
